import { Link, useOutletContext } from "react-router-dom";
import { PageNames, TabNames } from "../Assets/variables";
import { useEffect } from "react";

const APISwaggerRedirect = () => {
    const {setActiveTabItem} = useOutletContext();

    useEffect(() => {
        setActiveTabItem(TabNames.Swagger);
    }, []);

    return (
        <div id="tab-definition" className="api-panel">
            <div className="certification-alert">
                <span className="certification-alert__icon material-icons-outlined">info</span>
                <div>
                    <p><b>
                        This API does not have a REST end point.
                        <br />
                        To test out this API, please use the <Link to={`/${PageNames.GraphQLExplorer}`}>GraphQL Explorer</Link>.
                    </b></p>
                </div>
            </div>
        </div>
    );
};

export default APISwaggerRedirect;